import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { sendOtpCodeApi } from '@/api/v1/users/sendOtpCode';
import { resendOtpCodeApi } from '@/api/v1/users/resendOtpCodeApi';

export const sendOtpCode = async (code: string) => {
  const payload = {
    code,
  };

  try {
    const response = await sendOtpCodeApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const resendOtpCode = async () => {
  try {
    const response = await resendOtpCodeApi();

    return prepareResponse(response, ['retry-after']);
  } catch (e) {
    throwResponseError(e);
  }
};
